export const modulationContractOperationsCachekeys = {
  all: (modulation_user_contract_id: number) => [
    'modulation_user_contract_operations',
    modulation_user_contract_id
  ],
  update: (modulation_user_contract_id: number) => [
    'update_modulation_user_contract_operation',
    modulation_user_contract_id
  ],
  deleteOne: () => ['delete_modulation_user_contract_operation']
}
